import { render, staticRenderFns } from "./candidateGroupSelector.vue?vue&type=template&id=0884c3bf&scoped=true"
import script from "./candidateGroupSelector.vue?vue&type=script&lang=js"
export * from "./candidateGroupSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884c3bf",
  null
  
)

export default component.exports